export const dashboardDataInitial = {};

export interface DashboardProps {
  permissionToViewORF?: boolean;
  orfUrl?: string;
  arfUrl?: string;
  permissionToViewARF?: boolean;
  permissionToViewPaymentLimitsReport?: boolean;
  dashboardAlerts?: DashboardAlertPros[];
  surveyAlerts?: SurveyAlertPros[];
  announcements?: AnnouncementProps[];
  isViewAllAnnouncement?: boolean;
  messageCode?: number;
  message?: string;
  isSuccessMessage?: boolean;
  isErrorMessage?: boolean;
  isValidationMessage?: boolean;
}

export interface DashboardAlertPros {
  alertName?: string;
  alertCount?: number;
  pageToLoad?: string;
}
export interface SurveyAlertPros {
  surveyName?: string;
  tagLine?: number;
  pageToLoad?: string;
}

export interface AnnouncementProps {
  announcementKey?: number;
  subject?: string;
  content?: string;
  fromDate?: string;
  sentBy?: string;
  sentWhen?: string;
  filePath?: string;
}
